import * as React from 'react';
import { Box } from '@moosend/mooskin';

export const ImagePreviewWrapper: React.FC<{
	placeholder?: boolean;
	width?: number | string;
	maxH?: number | string;
	minH?: number | string;
	mb?: number | string;
}> = (props) => {
	return (
		<Box
			w={props.width || 600}
			borderRadius={5}
			border="solid 2px #293346"
			bgColor="backgroundColors.white"
			d="flex"
			direction="column"
			mb={props.mb || 50}
		>
			<Box p={15} d="flex" borderBottom="solid 2px #293346">
				<Box mr={15} w={14} h={14} borderRadius="50%" bgColor="#3fbaca" />
				<Box mr={15} w={14} h={14} borderRadius="50%" bgColor="#d84840" />
				<Box w={14} h={14} borderRadius="50%" bgColor="#f0b941" />
			</Box>
			<Box
				d="flex"
				align="flex-start"
				justify="center"
				border="none"
				// w={spinner ? '100%' : 'fit-content'}
				position="relative"
				overflowY="auto"
				overflowX="hidden"
				maxH={props.maxH || 530}
				minH={props.minH || 300}
				w="100%"
				px={props.placeholder ? 110 : undefined}
			>
				{props.children}
			</Box>
		</Box>
	);
};
